import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Config } from 'src/infrastructure/config';
import { CategoryTypes } from 'src/infrastructure/enums/categoryTypes';
import { Category } from 'src/models/DTO/categeroies/category';
import { LocalstorageService } from 'src/services/core/localstorage/localstorage.service';
import { CategoriesService } from 'src/services/request/categories/categories.service';
import { HistoryService } from 'src/services/state/history/history.service';

@Component({
  selector: 'app-sub',
  templateUrl: './sub.component.html',
  styleUrls: ['./sub.component.css']
})
export class SubComponent extends HistoryBaseComponent implements OnInit {

  private _subCategories?: Category = { data: [] };
  private _rootCategories?: Category;
  private _title: string = '';
  private _technicalCategoryUUID = Config.technicalCategoryUUID;
  private _autoAndRepairCategory = '0ac7a504-330a-4404-8ed3-5e70ed2c87b7';
  private _technicalCategories= Config.technicalCategories;

  private _autoAndRepairOrder = [
    "Моторни масла",
    "Акумулатори",
    "Резервни части",
    "Инструменти",
    "Гуми",
    "Аксесоари",
    "Течности",
    "Други"
  ];

  private _rootCategory = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private categoriesServices: CategoriesService,
    private localStorageService: LocalstorageService,
    protected location: Location,
    protected historyService: HistoryService

  ) {
    super(location, historyService);
    this._pageTitle = '';
    this.categoriesServices.getAllRootCategories().subscribe((response) => {
      this._rootCategories = response;
    })

  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(urlParams => {
      this._rootCategory = urlParams.id;
      let depth =  (this._technicalCategories.includes(urlParams.id)) ? 2 : 1;
      this.categoriesServices.getSubcategories(urlParams.id, depth).subscribe(response => {
        if (this._rootCategory == this._autoAndRepairCategory) {
          this._autoAndRepairOrder.forEach(orderedItem => {
            response.data.forEach(category => {
              if (category.name == orderedItem) {
                this._subCategories?.data.push(category);
              }
            });
          });
        }
        else {
          this._subCategories = response;
        }
        this._subCategories!.data.push(this._subCategories!.data.splice(this._subCategories!.data.findIndex(category => category.name == 'Други'), 1)[0]);

      })
      this._title = decodeURIComponent(decodeURIComponent(urlParams.title));
    });
  }

  get subCategories() {
    return this._subCategories?.data;
  }

  get title() {
    return this._title
  }

  get isCategoryWithImages() {
    return this._rootCategory == this._autoAndRepairCategory
  }

  goToSubCatProducts(subCategory: any) {
    if (this._rootCategory == this._technicalCategoryUUID) {
      this.router.navigate(['/categories/sub/' + subCategory.uuid + '/' + subCategory.name]);
      return;
    }
    const url = '/bottomtabs/categories/sub/products/' + subCategory.uuid + '/' + subCategory.name + '/' + CategoryTypes.child;
    this.localStorageService.setLocalStorageItem(Config.lsCatFromMain, url)
    this.router.navigate([url]);
  }

  getSubCategoryImageById(id: number) {
    return "/assets/images/categories/subcategory-" + id.toString() + '.png';
  }
}
